"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayUom = exports.isCoilNotAlwaysRequiredCut = exports.getProductQtyUomAndPricingUom = exports.getUsersDefaultUomValue = void 0;

var common_uom_1 = require("@ryerson/common.uom");

var common_process_cut_1 = require("@ryerson/common.process-cut");

var __1 = require("..");

var getUsersDefaultUomValue = function getUsersDefaultUomValue(productItem, profile) {
  var _a, _b, _c, _d, _e, _f;

  var _ref = (0, exports.getProductQtyUomAndPricingUom)(productItem),
      defaultQtyUom = _ref.defaultQtyUom,
      defaultPricingUom = _ref.defaultPricingUom,
      qtyUomOption = _ref.qtyUomOption,
      pricingUomOption = _ref.pricingUomOption;

  var userDefaultUom = profile && ((_b = (_a = profile === null || profile === void 0 ? void 0 : profile.settings) === null || _a === void 0 ? void 0 : _a.UOM) === null || _b === void 0 ? void 0 : _b.find(function (uom) {
    return uom.form === productItem.form;
  }));
  var defaultQuantityUom;

  if (productItem.cutFlag === __1.DefineCut.CutIsAlwaysRequired) {
    defaultQuantityUom = common_uom_1.pcs.value;
  } else {
    defaultQuantityUom = (_c = userDefaultUom === null || userDefaultUom === void 0 ? void 0 : userDefaultUom.quantityUOM) !== null && _c !== void 0 ? _c : (_d = defaultQtyUom[0]) === null || _d === void 0 ? void 0 : _d.value;
  }

  var _ref2 = productItem || {},
      defaultUOM = _ref2.defaultUOM;

  var defaultPriceUom;

  if (!productItem.isContractPrice) {
    if (userDefaultUom === null || userDefaultUom === void 0 ? void 0 : userDefaultUom.priceUOM) {
      defaultPriceUom = userDefaultUom === null || userDefaultUom === void 0 ? void 0 : userDefaultUom.priceUOM;
    } else if (defaultUOM) {
      defaultPriceUom = defaultUOM;
    } else {
      defaultPriceUom = (_e = defaultPricingUom[0]) === null || _e === void 0 ? void 0 : _e.value;
    }
  } else {
    defaultPriceUom = (_f = defaultPricingUom[0]) === null || _f === void 0 ? void 0 : _f.value;
  }

  return {
    defaultQtyUom: defaultQuantityUom,
    qtyUomOption: qtyUomOption,
    defaultPricingUom: defaultPriceUom,
    pricingUomOption: pricingUomOption
  };
};

exports.getUsersDefaultUomValue = getUsersDefaultUomValue;

function isCoil(form) {
  var coilForms = ["coil", "coiledBar", "coiledDrawnWire", "coiledTread", "coiledTube", "roll", "COIL", "COILED BAR", "COILED DRAWN WIRE", "COILED TREAD", "COILED TUBE", "ROLL"];
  return coilForms.includes(form);
}

var getProductQtyUomAndPricingUom = function getProductQtyUomAndPricingUom(productItem) {
  var _a;

  var quantityDefaultOption = common_uom_1.pcs;

  if (isCoil(productItem.form)) {
    quantityDefaultOption = common_uom_1.lbs;
  }

  var pricingDefaultOption;

  if (!productItem.isContractPrice) {
    pricingDefaultOption = common_uom_1.lb;
  } else {
    /**
     * Only use the unitsOfMeasure from the BE
     * if the current item is under contract.
     */
    switch (productItem.defaultUOM) {
      case common_uom_1.pc.value:
        {
          pricingDefaultOption = common_uom_1.pc;
          break;
        }

      case common_uom_1.lb.value:
        {
          pricingDefaultOption = common_uom_1.lb;
          break;
        }

      case common_uom_1.lbs.value:
        {
          pricingDefaultOption = common_uom_1.lb;
          break;
        }

      case common_uom_1.ft.value:
        {
          pricingDefaultOption = common_uom_1.ft;
          break;
        }

      case common_uom_1.inch.value:
        {
          pricingDefaultOption = common_uom_1.inch;
          break;
        }

      case common_uom_1.sqft.value:
        {
          pricingDefaultOption = common_uom_1.sqft;
          break;
        }

      case common_uom_1.sqin.value:
        {
          pricingDefaultOption = common_uom_1.sqin;
          break;
        }

      case common_uom_1.cwt.value:
        {
          pricingDefaultOption = common_uom_1.cwt;
          break;
        }

      default:
        pricingDefaultOption = common_uom_1.lb;
    }
  }

  var formOfProductItem = (0, __1.toCamelCase)((_a = productItem === null || productItem === void 0 ? void 0 : productItem.form) === null || _a === void 0 ? void 0 : _a.toLowerCase());
  var quantityUomOptions;
  /**
   * Commenting this out for now, until we can sort out the
   * requirements for the cutFlags in
   * https://ryerson.atlassian.net/browse/RY30-11858
   */

  /* 	if (isCoilNotAlwaysRequiredCut(productItem)) {
      quantityUomOptions = [pcs, lbs];
  } else { */

  quantityUomOptions = common_uom_1.uomOptions.quantity[formOfProductItem] || [quantityDefaultOption];
  /* 	} */

  var priceUomOptions;

  if (!productItem.isContractPrice) {
    priceUomOptions = common_uom_1.uomOptions.price[formOfProductItem] || [pricingDefaultOption];
  } else {
    priceUomOptions = productItem.unitOfMeasure.filter(function (uom) {
      return uom.isPricing;
    }).map(function (uom) {
      switch (uom.unitOfMeasure) {
        case common_uom_1.pc.value:
          {
            return common_uom_1.pc;
          }

        case common_uom_1.lb.value:
          {
            return common_uom_1.lb;
          }

        case common_uom_1.lbs.value:
          {
            return common_uom_1.lb;
          }

        case common_uom_1.ft.value:
          {
            return common_uom_1.ft;
          }

        case common_uom_1.inch.value:
          {
            return common_uom_1.inch;
          }

        case common_uom_1.sqft.value:
          {
            return common_uom_1.sqft;
          }

        case common_uom_1.sqin.value:
          {
            return common_uom_1.sqin;
          }

        case common_uom_1.cwt.value:
          {
            return common_uom_1.cwt;
          }

        default:
          return common_uom_1.lb;
      }
    });
  }

  var defaultQtyUom = [quantityDefaultOption];
  var defaultPricingUom = [pricingDefaultOption];
  return {
    defaultQtyUom: defaultQtyUom,
    qtyUomOption: quantityUomOptions,
    defaultPricingUom: defaultPricingUom,
    pricingUomOption: priceUomOptions
  };
};

exports.getProductQtyUomAndPricingUom = getProductQtyUomAndPricingUom;

var isCoilNotAlwaysRequiredCut = function isCoilNotAlwaysRequiredCut(productItem) {
  var _a;

  return ((_a = productItem === null || productItem === void 0 ? void 0 : productItem.form) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === common_process_cut_1.Form.COIL && (productItem === null || productItem === void 0 ? void 0 : productItem.cutFlag) !== __1.DefineCut.CutIsAlwaysRequired;
};

exports.isCoilNotAlwaysRequiredCut = isCoilNotAlwaysRequiredCut;

var getDisplayUom = function getDisplayUom(form, qtyUOM) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "quantity";

  var _a;

  var display = qtyUOM.toLowerCase();

  if (form && qtyUOM) {
    var optionsType = common_uom_1.uomOptions[type];
    /** type here should technically be
     * UOM_OPTIONS_PRICING[] | UOM_OPTIONS_QUANTITY[]
     * but writing it that way causes a type error
     * */

    var optionsArray = optionsType[(0, __1.toCamelCase)(form.toLowerCase())];
    display = ((_a = optionsArray === null || optionsArray === void 0 ? void 0 : optionsArray.find(function (item) {
      return item.value.toLowerCase() === qtyUOM.toLowerCase();
    })) === null || _a === void 0 ? void 0 : _a.display) || qtyUOM;
  }

  return display;
};

exports.getDisplayUom = getDisplayUom;